import { baseApi } from "./api";

export const boqApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		saveBoQ: build.mutation({
			query: ({ projectId, lvId, gaebData, finalize = false }) => ({
				url: `projects/${projectId}/lvs/${lvId}/boq`,
				method: "PUT",
				body: { gaebData, finalize },
			}),
			invalidatesTags: (_result, _error, { projectId, lvId }) => [
				{ type: "BoQ", id: lvId },
				{ type: "LV", id: lvId },
				// Finalizing syncs lv_positions, which flips the category's
				// hasReadyLV flag the invoice flow gates on - refresh lv-status.
				{ type: "TicketCategory", id: `lv-status-${projectId}` },
			],
		}),
		validateBoQ: build.mutation({
			query: ({ projectId, lvId, gaebData }) => ({
				url: `projects/${projectId}/lvs/${lvId}/boq/validate`,
				method: "POST",
				body: { gaebData },
			}),
		}),
		reopenBoQ: build.mutation({
			query: ({ projectId, lvId }) => ({
				url: `projects/${projectId}/lvs/${lvId}/boq/reopen`,
				method: "PATCH",
			}),
			invalidatesTags: (_result, _error, { projectId, lvId }) => [
				{ type: "BoQ", id: lvId },
				{ type: "LV", id: lvId },
				// Reopen deletes lv_positions, flipping hasReadyLV back to false.
				{ type: "TicketCategory", id: `lv-status-${projectId}` },
			],
		}),
	}),
});

export const {
	useSaveBoQMutation,
	useValidateBoQMutation,
	useReopenBoQMutation,
} = boqApi;
